import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import './index.scss';
import Bugsnag from '@bugsnag/js';
import PSButton from '../../components/PSButton';
import PSTextInput from '../../components/PSTextInput';
import { loginUser } from '../../redux/ducks/user-loginDuck';
import PSError from '../../components/PSError';
import { Routes } from '../../../routes';
import { loginByOrg, pathServer, showSuccessToast } from '../../shared/constants/Constants';
import PSLabel from '../../components/PSLabel';
import PSHeaderHome from '../../components/PSHeaderHome';
import PSIcon from '../../components/PSIcon';

export default function LoginPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const { errorLogin } = useSelector((state) => state.user);
  const [loading, setLoading] = useState();
  const org = loginByOrg[id];

  const login = async (user, password) => {
    setLoading(true);
    await dispatch(loginUser(user, password));
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      user: '',
      password: '',
    },
    validationSchema: Yup.object().shape({
      user: Yup.string().required('Usuario  es requerido'),
      password: Yup.string()
        .min(8, 'Necesita mínimo 6 caracteres')
        .required('La contraseña es requerida'),
    }),

    onSubmit(form) {
      const { user, password } = form;
      login(user, password);
    },
  });

  useEffect(() => {
    if (errorLogin === null) {
      history.push(Routes.HOME);
    }
  }, [errorLogin]);

  return (
    <>
      {org ? (
        <div className="login-container">
          <div className="container-img">
            <img src={`${pathServer.PATH_IMG}login/${org.img}`} className="img-org" />
          </div>
          <div className="container-left">
            <PSIcon type={org.logo} className="icon-org" />
            <div className="container-content">
              <div className="content">
                <div className="content-title">
                  <h2>Bienvenido</h2>
                  <span>Iniciar sesión</span>
                </div>
                <form className="login-form" onSubmit={formik.handleSubmit} noValidate>
                  <div className="form-container">
                    <PSTextInput
                      placeholder="Usuario"
                      type="text"
                      {...formik.getFieldProps('user')}
                    />
                    <PSError>{formik.touched.user && formik.errors.user}</PSError>
                    <PSTextInput
                      type="password"
                      placeholder="Contraseña"
                      {...formik.getFieldProps('password')}
                    />
                    <PSError>{formik.touched.password && formik.errors.password}</PSError>
                    <div className="login-submit">
                      <PSButton
                        type="submit"
                        loading={loading}
                        className={
                          formik.isValid && formik.dirty ? ' submit' : ' submit submit-disabled'
                        }
                      >
                        Ingresar
                      </PSButton>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No se ha encontrado la página solicitada</div>
      )}
    </>
  );
}
